export const COLOR_DEVICE_AIRNODE = '#2470A2';
export const COLOR_DEVICE_EMERGENCY = '#EB5861';
export const COLOR_DEVICE_BEACON = '#B84ED2';
export const COLOR_VITALSIGN = '#48C9D9';

export const COLOR_ALERT_GETUP = '#FEB341';
export const COLOR_ALERT_MOVEMENT = '#F8B7AD';
export const COLOR_ALERT_NOT_TURN_FOR = '#009D9A';
export const COLOR_ALERT_NO_MOVEMENT_FOR = '#006469';
export const COLOR_ALERT_FALL = '#E50610';
export const COLOR_ALERT_OUT_OF_AREA = '#767676';
export const COLOR_ALERT_INTO_AREA = '#10b0c3';
export const COLOR_ALERT_WALKING_AT_NIGHT = '#77C25C';
export const COLOR_ALERT_BATTERY_LOW = '#B84ED2';
export const COLOR_ALERT_EMERGENCY_ALARM = '#EB5861';

export const COLOR_TARGET = '#E1EBF1';
export const COLOR_TOTAL = '#CCBCD7';
export const COLOR_WALKING = '#EB5861';
export const COLOR_STANDING = '#F4724D';
export const COLOR_SITTING = '#F8B7AD';
export const COLOR_LYING = '#006469';
export const COLOR_LYING_ON_BACK = '#006469';
export const COLOR_LYING_ON_STOMACH = '#9CEFE5';
export const COLOR_LYING_ON_LEFT_SIDE = '#48C9D9';
export const COLOR_LYING_ON_RIGHT_SIDE = '#009D9A';
export const COLOR_LOCATION = [
  '#BF7217',
  '#FFA030',
  '#CAA12D',
  '#FAD05A',
  '#AADB43',
  '#77C25C',
  '#21834B',
  '#46A680',
  '#6FADD7',
  '#2470A2',
  '#ADC8F0',
  '#608AD3',
  '#5067AB',
  '#AA91E7',
  '#5C488D',
  '#E899FC',
  '#B84ED2',
  '#F56FD8',
  '#DD2FB7',
  '#66CDAA',
  '#8FBC8B',
  '#20B2AA',
  '#008B8B',
  '#9ACD32',
  '#3CB371',
  '#4682B4',
  '#B0C4DE',
  '#B0E0E6',
  '#00BFFF',
  '#6495ED',
  '#191970',
  '#808080',
  '#BC8F8F',
  '#CD5C5C',
  '#F08080',
  '#FFA07A',
  '#FA8072',
  '#E9967A',
  '#E6E6FA',
  '#D8BFD8',
  '#DDA0DD',
  '#EE82EE',
  '#7B68EE',
  '#800080',





];
